/* The booked and request-sent pages (prototype .c2, .ticket, .tRows, .prep, .actions, .c2Tg), in the telify layer. */
@layer telify {
  .c2 {
    width: min(640px, calc(100% - 80px));
    margin: 0 auto;
    padding: 80px 0 96px;
  }

  .serif {
    font-family: var(--font-display);
    font-weight: 500;
    letter-spacing: -0.015em;
  }

  .label {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--text-tertiary);
  }

  .head {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .check {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: var(--accent);
    color: var(--text-on-accent);
  }

  /* The icon fills most of its circle (Gabriel 2026-10-23). */
  .check svg {
    width: 30px;
    height: 30px;
    stroke-width: 2.2;
  }

  .title {
    margin-top: 28px;
    font-size: 68px;
    line-height: 1;
    letter-spacing: -0.025em;
  }

  .lead {
    margin-top: 22px;
    font-size: 20px;
    line-height: 1.6;
    color: var(--text-primary);
    max-width: 36ch;
  }

  .ticket {
    margin-top: 56px;
    border-top: var(--line-strong);
    border-bottom: var(--line-strong);
  }

  /* Under the booking page's own heading: the rows alone, between the ticket's rules. */
  .ticketBare {
    margin-top: 0;
  }

  /* A row's note under its words (the place's note on the booking page). */
  .note {
    display: block;
    margin-top: 10px;
    font-size: 14.5px;
    font-weight: 400;
    line-height: 1.55;
    font-style: italic;
    color: var(--text-secondary);
  }

  .tHead {
    display: grid;
    grid-template-columns: 76px 1fr;
    gap: 20px;
    align-items: center;
    padding: 24px 0;
  }

  .tThumb {
    width: 76px;
    height: 76px;
    border-radius: 8px;
    overflow: hidden;
    background: var(--tint);
  }

  .tName {
    font-size: 30px;
    line-height: 1.1;
  }

  .tWith {
    margin-top: 4px;
    font-size: 16px;
    color: var(--text-primary);
  }

  .perf {
    height: 0;
    border-top: 1.5px dashed var(--field-line);
  }

  .tRows {
    margin: 0;
    padding: 6px 0 10px;
  }

  .tRows > div {
    display: grid;
    grid-template-columns: 140px 1fr auto;
    gap: 20px;
    padding: 14px 0;
    align-items: baseline;
  }

  .tRows > div + div {
    border-top: 1px solid var(--border-subtle);
  }

  .tRows dt {
    font-size: 16px;
    color: var(--text-tertiary);
  }

  .tRows dd {
    margin: 0;
    font-size: 17px;
    font-weight: 500;
    line-height: 1.5;
  }

  .sub {
    display: block;
    font-weight: 400;
    font-size: 16px;
  }

  .amt {
    font-size: 17px;
    font-weight: 600;
    color: var(--accent);
  }

  /* A row's own action on its right (Gabriel 2026-10-22): Get directions, and Add to Calendar in its look. */
  .dirLink {
    appearance: none;
    border: 0;
    background: none;
    padding: 0;
    font-family: inherit;
    cursor: pointer;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 16px;
    font-weight: 400;
    color: var(--text-primary);
    text-decoration: underline;
    text-decoration-color: var(--text-muted);
    text-underline-offset: 4px;
  }

  .dirLink svg {
    color: var(--text-tertiary);
  }

  .actions {
    margin-top: 52px;
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .tg {
    margin-top: 40px;
    padding-top: 28px;
    border-top: 1px solid var(--border-subtle);
    text-align: center;
    display: grid;
    justify-items: center;
    gap: 18px;
  }

  .tgLine {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
    font-size: 16px;
    line-height: 1.55;
    color: var(--text-primary);
  }

  .tgLine > svg {
    margin-top: 3px;
    color: var(--text-tertiary);
  }

  .cancel {
    margin-top: 28px;
    text-align: center;
  }

  .dangerLink {
    appearance: none;
    background: none;
    border: 0;
    padding: 0;
    cursor: pointer;
    font: inherit;
    font-size: 15px;
    color: var(--danger);
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  .problem {
    margin-top: 12px;
    font-size: 14px;
    color: var(--danger);
  }

  .payNow {
    margin-top: 40px;
  }

  /* A signed-out visitor on the booked or pay page: the sign-in step, in the page's width. */
  .signInWrap {
    padding: 64px 0 96px;
  }

  /* web-studio-sites D12: a custom site's Pay now (telify-pages.html .col, .payHead and .ticket): her column, the title
     at its top with no mark above it. */
  :global(:root[data-custom-site]) .pay {
    width: min(680px, calc(100% - 64px));
    padding: 56px 0 120px;
  }

  :global(:root[data-custom-site]) .pay .title {
    margin-top: 0;
    font-size: 56px;
  }

  :global(:root[data-custom-site]) .pay .ticket {
    margin-top: 44px;
  }

  /* web-studio-sites D12: a custom site's narrow booked and request-sent pages (bookings.html .c2 and .tRows at 860 pixels),
     and its narrow Pay now and a booking's page ticket (telify-pages.html .payHead, .ticket and .tRows at 860). */
  @media (max-width: 860px) {
    :global(:root[data-custom-site]) .c2 {
      width: calc(100% - 32px);
      padding-top: 40px;
    }

    :global(:root[data-custom-site]) .title {
      font-size: 44px;
    }

    :global(:root[data-custom-site]) .tRows > div {
      grid-template-columns: 92px minmax(0, 1fr);
    }

    /* A row's own action (the amount, Get directions, Add to Calendar) moves under its value. */
    :global(:root[data-custom-site]) .tRows > div > :nth-child(n + 3) {
      grid-column: 2;
      justify-self: start;
    }

    /* A row with no action keeps an empty cell, which would add a blank line under its value. */
    :global(:root[data-custom-site]) .tRows > div > span:empty {
      display: none;
    }

    :global(:root[data-custom-site]) .actions > * {
      width: 100%;
    }

    :global(:root[data-custom-site]) .pay {
      padding-top: 36px;
      padding-bottom: 80px;
    }

    :global(:root[data-custom-site]) .pay .title {
      font-size: 38px;
    }

    :global(:root[data-custom-site]) .pay .ticket {
      margin-top: 30px;
    }

    :global(:root[data-custom-site]) .pay .tHead {
      grid-template-columns: 64px 1fr;
      gap: 16px;
    }

    :global(:root[data-custom-site]) .pay .tThumb {
      width: 64px;
      height: 64px;
    }

    :global(:root[data-custom-site]) .pay .tName {
      font-size: 25px;
    }

    :global(:root[data-custom-site]) .pay .tRows > div,
    :global(:root[data-custom-site]) .ticketBare .tRows > div {
      gap: 4px 16px;
    }

    :global(:root[data-custom-site]) .pay .tRows dt,
    :global(:root[data-custom-site]) .ticketBare .tRows dt {
      font-size: 15px;
    }

    :global(:root[data-custom-site]) .pay .tRows dd,
    :global(:root[data-custom-site]) .ticketBare .tRows dd {
      font-size: 16px;
    }
  }
}
